import { TableHeading } from "../../../components/common/table/TableDesign";
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

/*----------------------------*/
/* Quote Screen */
/*----------------------------*/
export const customerQuoteChargesHeading: TableHeading[] = [
  { label: "Service" },
  { label: "Service Description", align: "left" },
  { label: "Price", align: "center" },
  { label: "Status", align: "center" },
  { label:'Date', align:'center' },
  { label: "Job Status", align: "center" },
];

export const customerQuoteChargesFields = [
  // {
  //   id: "typeName",
  //   type: "staticText",
  // },
  {
    id: "typeName",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isDisabled: true,
  },
  {
    id: "description",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isDisabled: true,
  },

  {
    id: "price",
    placeholder: "Charge",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
    isDisabled: true,
  },
  {
    id: "status",
    type:"radio",
    radioOptions:[
      {label:'Accept', value:'accept'},
      {label:'Decline', value:'decline'},
    ],
    labelPlacement:"end",
    width: "160px",
  },
  {
    id:'date',
    type:'date',
    width:'160px',
  },
  {
    id: "jobStatus",
    type: "radio",
    radioOptions:[
      {label:'Fixed', value:'fixed'},
      {label:'Provisional', value:'provisional'},
      {label:'Awaiting', value:'awaiting'},
    ],
    labelPlacement:"end",
     width: "160px",
  }
];

export const customerMaterialsHeading: TableHeading[] = [
  { label: "Materials" },
  // { label: "Surveyed Qty", align: "left" },
  { label: "Charge Qty", align: "left" },
  { label: "Rate", align: "center" },
  { label: "Total", align: "center" },
  // { label: "Volume", align: "center" },
  // { label: "Cost", align: "center" },
];

export const customerMaterialsFields = [
  {
    id: "name",
    type: "staticText",
  },
  // {
  //   id: "surveyedQty",
  //   placeHolder: "",
  //   type: "text",
  //   width: "100px",
  //   disabled: true,
  //   inputProps: {
  //     maxLength: 6,
  //   },
  //   valueFormat: "number",
  //   patternAllowed: patternConstant?.NUMERIC,
  // },
  {
    id: "chargeQty",
    placeHolder: "",
    type: "text",
    width: "100px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "price",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "total",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  // {
  //   id: "volume",
  //   placeHolder: "",
  //   type: "text",
  //   width: "70px",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   disabled: true,
  //   valueFormat: "price",
  //   patternAllowed: patternConstant?.PRICE,
  // },
  // {
  //   id: "cost",
  //   placeHolder: "",
  //   type: "text",
  //   width: "70px",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   disabled: true,
  //   valueFormat: "price",
  //   prefixIcon: "£",
  //   patternAllowed: patternConstant?.PRICE,
  // },
];